import HeroSection from "@/components/HeroSection";
import MarqueeBar from "@/components/MarqueeBar";
import AboutSection from "@/components/AboutSection";
import ServicesGrid from "@/components/ServicesGrid";
import TechShowcase from "@/components/TechShowcase";
import WhyChooseUs from "@/components/WhyChooseUs";
import WorkflowTimeline from "@/components/WorkflowTimeline";
import ContactForm from "@/components/ContactForm";

export default function HomePage() {
    return (
        <main>
            <HeroSection />
            <MarqueeBar />
            <AboutSection />
            <ServicesGrid />
            <TechShowcase />
            <WhyChooseUs />
            <WorkflowTimeline />
            <ContactForm />
        </main>
    );
}
